import React, { useState } from "react"

import { CommentEditComposer } from "./CommentEditComposer"
import { CommentReadComposer } from "./CommentReadComposer"
import { memo } from "react"

const MainComment = memo(
  ({ commentText, commentId, commentTextBlockId, isEditComment, setIsEditComment }) => {
    const [textContent, setTextContent] = useState(commentText)

    return (
      <>
        {textContent && (
          <>
            {isEditComment ? (
              <CommentEditComposer
                setTextContent={setTextContent}
                commentId={commentId}
                commentText={textContent}
                commentTextBlockId={commentTextBlockId}
                setIsEditComment={setIsEditComment}
              />
            ) : (
              <CommentReadComposer text={textContent} />
            )}
          </>
        )}
      </>
    )
  },
)

MainComment.displayName = "MainComment"

export default MainComment
